const ticketsSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="89.742px" height="89.853px" viewBox="0 0 89.742 89.853" enable-background="new 0 0 89.742 89.853" xml:space="preserve">
<g id="Layer_1">
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
<g>
<g>
<g>
<circle cx="63.45" cy="72.325" r="3.505"/>
<circle cx="55.387" cy="27.103" r="3.506"/>
<path d="M86.237,54.797h3.505V33.764h-8.939c-3.866,0-7.011-3.146-7.011-7.012c0-2.623,1.448-5.007,3.78-6.222l2.986-1.555
L71.632,0L0.082,33.748l0.008,0.016H0v21.033h3.506c3.865,0,7.011,3.146,7.011,7.012c0,3.865-3.146,7.011-7.011,7.011H0v21.033
h89.742V68.819h-3.505c-3.866,0-7.013-3.146-7.013-7.011C79.225,57.942,82.371,54.797,86.237,54.797z M47.704,19.038
c0.852,1.69,2.896,2.407,4.619,1.596c1.726-0.811,2.478-2.848,1.714-4.583l14.238-6.716l3.247,6.903
c-2.982,2.625-4.742,6.424-4.742,10.515c0,2.553,0.689,4.947,1.887,7.011H16.483L47.704,19.038z M82.73,75.387v7.455H66.956
c0-1.937-1.569-3.506-3.506-3.506c-1.936,0-3.506,1.569-3.506,3.506H7.011v-7.455c6.042-1.561,10.517-7.057,10.517-13.578
c0-6.522-4.475-12.018-10.517-13.579v-7.455h52.934c0,1.937,1.569,3.506,3.506,3.506s3.505-1.569,3.505-3.506H82.73v7.455
c-6.041,1.562-10.517,7.057-10.517,13.579C72.214,68.33,76.689,73.826,82.73,75.387z"/>
<circle cx="63.45" cy="51.292" r="3.505"/>
<circle cx="63.45" cy="61.808" r="3.505"/>
</g>
</g>
</g>
</g>
</svg>

`;

export default ticketsSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/ticketsSVG.js